<ngb-alert type="warning" [dismissible]="false" style="padding-bottom: 20px;">
  {{ 'SLA_ISSUE' | translate}}
  <button *ngIf="fromService" type="button" class="btn btn-danger float-left" (click)="createIssue()">
    {{ 'ISSUE_CREATE' | translate}} {{ 'COMPENSATE_SLA' | translate}}</button>
</ngb-alert>

<ngb-alert *ngIf="error" type="danger" [dismissible]="false">
  {{ error }}
</ngb-alert>

<table class="w-100 table table-striped table-bordered">
  <thead>
    <tr>
      <th><button *ngIf="!loading" type="button" class="btn btn-link header" (click)="load()">{{'REFRESH' | translate}}
        </button>
        <span *ngIf="loading" class="header">{{'REFRESHING' | translate}}</span>
      </th>
      <th>{{'TIME' | translate}} ({{ 'MINUTES' | translate}})</th>
    </tr>
  </thead>
  <tbody *ngIf="data">
    <tr>
      <td>{{ 'SLA_PLR' | translate}}</td>
      <td>{{ data.sla_plr | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_LATENCY' | translate}}</td>
      <td>{{ data.sla_latency | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_DC' | translate}}</td>
      <td>{{ data.sla_dc | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_CIR' | translate}}</td>
      <td>{{ data.sla_cir | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_MTTR' | translate}}</td>
      <td>{{ data.sla_mttr | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_TIME' | translate}}</td>
      <td>{{ data.sla_time | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_MAX' | translate}}</td>
      <td>{{ data.sla_max | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_ILLEGAL' | translate}}</td>
      <td>{{ data.sla_illegal | number}}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_K' | translate}}</td>
      <td>{{ data.sla_k }}</td>
    </tr>
    <tr>
      <td>{{ 'SLA_PENALTY' | translate}}</td>
      <td>{{ data.sla_penalty * 100 }}%</td>
    </tr>
    <tr>
      <td>{{ 'SLA_AMOUNT' | translate}}</td>
      <td>{{ data.sla_amount | number}}</td>
    </tr>
  </tbody>
</table>